import React, { useState } from 'react'
import { Accordion, Button, Col, Modal, Row, Container } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { EventDetailList } from './EventDetailTable'
// @ts-ignore
import ModalImage from 'react-modal-image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useLocation, useNavigate } from 'react-router-dom'
import { CoverPhoto, IEvent } from '../../store/events/interfaces'
import { isMobileQuery, isTabletOrMobileQuery } from '../../utils'
import { useMediaQuery } from 'react-responsive'
import { addToast } from '../../store/misc/misc'
import { ToastType } from '../../store/misc/interfaces'
import { addRegistration, removeRegistration } from '../../store/registrations/registrations'
import { stages } from '../../routes'
import { checkRegIntegrity } from '../../functions/events/EventIntegrity'

export const EventModal = (props: {
  eventId: number
  events: IEvent[]
  editable?: boolean
}) => {
  const { eventId, events, editable } = props
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const location = useLocation()
  const parentStage = stages.find(stage =>
    location.pathname.includes(stage.path),
  )

  const isTabletOrMobile = useMediaQuery(isTabletOrMobileQuery)
  const isMobile = useMediaQuery(isMobileQuery)

  const [open, setOpen] = useState(false)

  const { data: program } = useSelector((state: RootState) => state.program)
  const { baseUrl } = useSelector((state: RootState) => state.misc)
  const { list: regs } = useSelector((state: RootState) => state.registrations)
  const { loadedViaCode } = useSelector((state: RootState) => state.misc)

  const eventIdx = events.findIndex(event => event.event_id === eventId)
  const event = events[eventIdx]

  const { originalRegistrationIds } = useSelector(
    (state: RootState) => state.participant.data,
  )
  const isOriginalReg = originalRegistrationIds?.includes(event?.event_id)
  const isOver: boolean = Boolean(event?.end) && new Date(event?.end) < new Date()
  const isEventFull = event && (event.max_participants !== null && event.max_participants !== 0) && (event.registration_statistics.registration_amount_yes >= event.max_participants && event.registration_statistics.is_waiting_list_full)

  if (event === undefined) {
    return <></>
  } else {
    let currentDate = new Date()
    let eventDate = new Date(event.first_registration_date)

    const isRegistrationDateChangeAllowed = program.is_organizer_registration_date_change_allowed && eventDate > currentDate;

    const isExternal = event.has_external_registration;

    const hasRegistration = regs.some(
      reg => reg.event.event_id === event.event_id,
    )
    const nextItem =
      eventIdx === events.length - 1 ? undefined : events[eventIdx + 1]
    const prevItem = eventIdx === 0 ? undefined : events[eventIdx - 1]

    return (
      <>
        <Modal
          size='xl'
          dialogClassName={!isMobile ? 'modal-90w' : ''}
          show={true}
          animation={false}
          onHide={
            () => {
              navigate(
                `${parentStage?.path}`, { replace: true },
              )
            }
          }
        >
          <Modal.Header closeButton closeLabel={'Modal schließen'}>
            <Modal.Title className='w-100'>
              <strong>{event.name}</strong>
              {event.cover_photo && program.enable_preview_images ? (
                  <div className="event-detail-cover-image-wrapper">
                    <ModalImage
                        small={event.cover_photo.medium}
                        large={event.cover_photo.medium}
                        alt={
                            event.cover_photo.caption
                                ? event.cover_photo.caption
                                : `Vorschaubild der Veranstaltung ${event.name}`
                        }
                        className="event-detail-cover-image"
                    />
                  </div>
              ) : (
                  <></>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Teaser, Description */}
            <Row className='border-bottom mb-3'>
              <Col md={12}>
                <h3>Kurzbeschreibung</h3>
                <p>{event.teaser}</p>
              </Col>
              <Accordion className='col-md-12 mb-1'>
                <Accordion.Toggle
                  as={Button}
                  variant='button'
                  eventKey='0'
                  onClick={() => setOpen(!open)}
                  className='btn btn-info mb-3 details-button'
                  aria-expanded={open}
                >
                  <span
                    className={
                      `${isTabletOrMobile && 'text-left'}`
                    }
                  >
                    Detaillierte Beschreibung{' '}
                    <FontAwesomeIcon
                      icon={open ? 'caret-down' : 'caret-right'}
                    />
                  </span>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey='0'>
                  <Col md={12} className='pb-2 pt-2 mb-3'>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: event.description_html,
                      }}
                    />
                  </Col>
                </Accordion.Collapse>
              </Accordion>
            </Row>
            {/* Event Details */}
            <Row>
              <Col md={12}>
                <EventDetailList event={event} />
              </Col>
            </Row>
            {/* Images */}
            {event.photos.length > 0 && (
              <Row>
                <Accordion>
                  <Col md={12} className='mt-3'>
                    <Accordion.Toggle
                        as={Button}
                        variant='button'
                        eventKey='0'
                        onClick={() => setOpen(!open)}
                        aria-expanded={open}
                        className='btn-info'
                    >
                        <h6 className='mb-0'>Bildergalerie öffnen <FontAwesomeIcon icon={open ? 'caret-down' : 'caret-right'} /></h6>
                    </Accordion.Toggle>
                  </Col>
                  <Accordion.Collapse eventKey="0">
                    <Container fluid>
                      <Row className='justify-content-between'>
                        {event.photos.map((photo: CoverPhoto, key) => (
                          <Col
                            xl={3}
                            lg={4}
                            md={6}
                            className='m-3 px-0 d-flex flex-column align-items-left justify-content-between border rounded'
                            key={
                              event.event_id +
                              `${photo.thumbnail &&
                              photo.thumbnail.split('/').pop()}`
                            }
                          >
                            <ModalImage
                              className='bg-white rounded img-fluid card-img-top modal-image-fix'
                              small={photo.medium}
                              large={photo.medium}
                              alt={
                                photo.caption
                                  ? photo.caption
                                  : `Bild ${key + 1} der Veranstaltung ${
                                    event.name
                                  }`
                              }
                            />
                              <div className='pt-4'>
                                <h5 className='text-dark px-4'>{photo.credits || '-'}</h5>
                                <p className="small mb-0 px-4">{photo.caption || '-'}</p>
                                <hr/>
                                <p className="small text-muted px-4">{photo.source || '-'}</p>
                              </div>
                          </Col>
                        ))}
                      </Row>
                    </Container>
                  </Accordion.Collapse>
                </Accordion>
              </Row>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className='w-100'>
              <Row>
                <Col md={6} sm={12} className='d-block d-md-flex'>
                  {prevItem !== undefined && parentStage && (
                    <Button
                      variant='outline-dark'
                      onClick={() => {
                        navigate(
                          `${parentStage.path}/${prevItem.event_id}`, { replace: true },
                        )
                      }}
                      className='mobile-btn'
                    >
                      <FontAwesomeIcon
                        icon='chevron-left'
                        role='presentation'
                      />{' '}
                      vorherige Veranstaltung
                    </Button>
                  )}
                  {nextItem !== undefined && parentStage && (
                    <Button
                      variant='outline-dark'
                      className='ml-0 ml-md-2 mobile-btn'
                      onClick={() => {
                        navigate(
                          `${parentStage.path}/${nextItem.event_id}`, { replace: true },
                        )
                      }}
                    >
                      Nächste Veranstaltung{' '}
                      <FontAwesomeIcon
                        icon='chevron-right'
                        role='presentation'
                      />
                    </Button>
                  )}
                </Col>
                <Col
                  md={6}
                  sm={12}
                  className='d-block d-md-flex justify-content-end'
                >
                  {program.is_participant_registration_allowed ?
                    <>
                      {editable && (
                        <Button
                          variant={hasRegistration ? 'success' : 'info'}
                          className='mobile-btn'
                          disabled={
                            event.has_external_registration ||
                            event.canceled ||
                            (loadedViaCode && hasRegistration && isOriginalReg) ||
                            isOver || isRegistrationDateChangeAllowed ||
                            isEventFull
                          }
                          onClick={() => {
                            if (
                              regs.some(
                                reg => reg.event.event_id === event.event_id,
                              )
                            ) {
                              dispatch(removeRegistration(event.event_id))
                            } else {
                              const issueToast = checkRegIntegrity(
                                event,
                                regs,
                                program,
                              )
                              if (issueToast) {
                                dispatch(addToast(issueToast))
                                if (issueToast.type === ToastType.Warning) {
                                  dispatch(addRegistration(event))
                                }
                              } else {
                                dispatch(addRegistration(event))
                              }
                            }
                          }}
                        >
                          {
                            event.canceled ?
                                <>
                                  <FontAwesomeIcon icon='ban' role='presentation' />
                                  &nbsp;Abgesagt
                                </> :
                            isEventFull ?
                                <>
                                  <FontAwesomeIcon icon='ban' role='presentation' />
                                  &nbsp;Voll
                                </> :
                            isOver ?
                                <>
                                  <FontAwesomeIcon icon='calendar-times' role='presentation' />
                                  &nbsp;Vorbei
                                </> :
                            isRegistrationDateChangeAllowed ?
                                <>
                                  <FontAwesomeIcon icon='calendar-day' role='presentation' />
                                  &nbsp;Ab dem {eventDate.toLocaleDateString('de-DE')}
                                </> :
                            isExternal ?
                                <>
                                  <FontAwesomeIcon icon='external-link-square-alt' role='presentation' />
                                  &nbsp;Externe Anmeldung
                                </> :
                            loadedViaCode && hasRegistration && isOriginalReg ?
                                <>
                                  <FontAwesomeIcon icon='check-circle' role='presentation' />
                                  &nbsp;Bereits registriert
                                </> :
                            hasRegistration ?
                                <>
                                  <FontAwesomeIcon icon='minus-circle' role='presentation' />
                                  &nbsp;Abwählen
                                </> :
                            <>
                              <FontAwesomeIcon icon="plus-circle" />
                              &nbsp;Auswählen
                            </>
                          }
                        </Button>
                      )}
                    </>
                  : "" }
                  <Button
                    variant='secondary'
                    onClick={() => navigate(
                      `${parentStage?.path}`, { replace: true },
                    )}
                    className='mobile-btn ml-0 ml-md-2'
                  >
                    Schließen
                  </Button>
                </Col>
              </Row>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    )
  }
}
